// note: берем из кеша rtkq
import { createSelector } from '@reduxjs/toolkit';
import { getDictionaryByElementProperty } from 'helper';
import { rtkDatasourceTypesSelector } from 'Services/api/datasourceTypesApiTS';

export const datasourceTypesSelectorMonitoring = rtkDatasourceTypesSelector;
export const datasourceTypesDictionarySelectorMonitoring = createSelector(
    datasourceTypesSelectorMonitoring,
    (datasourceTypes) => {
        return getDictionaryByElementProperty(datasourceTypes, 'id');
    },
);
export const datasourceTypesIdsSelectorMonitoring = createSelector(
    datasourceTypesSelectorMonitoring,
    (datasourceTypes) => {
        return datasourceTypes.map(({ id }) => id);
    },
);

export const datasourceTypeSelectorMonitoring = (datasourceTypeId: number) => createSelector(
    [datasourceTypesDictionarySelectorMonitoring],
    (dataSourceTypes) => dataSourceTypes[datasourceTypeId],
);
